"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const joi = require("@hapi/joi");
const Primitives = {
    string: joi.string().allow(''),
    number: joi.number(),
    boolean: joi.bool(),
    date: joi.date().strict(),
};
const ObjectSchema = (schema, options = { allowUnknown: false, stripUnknown: false }) => joi.object().keys(schema).options(options).min(1);
/**
 * Builds a schema to validate the `WhereOptions` type, based on the given schema.
 */
exports.WhereOptionsSchema = (schema) => {
    const [, options] = ValueOrOptions(schema.describe());
    return options;
};
const ValueOrOptions = (schema) => {
    const value = WhereValueSchema(schema);
    const options = _WhereOptionsSchema(schema, value);
    return [value, options];
};
const WhereValueSchema = (schema) => {
    const primitive = Primitives[schema.type];
    const attributes = WhereAttributesSchema(schema);
    return joi.alternatives([
        ...(primitive ? [primitive, joi.array().items(primitive)] : []),
        ...(attributes ? [attributes, joi.array().items(attributes)] : []),
        WhereOperatorsSchema,
    ]);
};
const _WhereOptionsSchema = (schema, values) => {
    const attributesSchema = WhereAttributesSchema(schema);
    const attributes = attributesSchema ? [attributesSchema] : [];
    const and = ObjectSchema({ $and: values.required() });
    const or = ObjectSchema({ $or: values.required() });
    const andOr = ObjectSchema({ $and: or.required() });
    const orAnd = ObjectSchema({ $and: and.required() });
    return joi.alternatives([...attributes, and, andOr, or, orAnd]);
};
/**
 * Equivalent of `WhereAttributes` type;
 *
 * Maps object schema entries to `{ [key]: WhereValue | WhereOptions }`
 */
const WhereAttributesSchema = (schema) => schema.type === 'object'
    ? ObjectSchema(Object.entries(schema.children)
        .map(([key, val]) => [key, joi.alternatives(ValueOrOptions(val))])
        .reduce((obj, [key, val]) => ({ ...obj, [key]: val }), {}), { allowUnknown: true, stripUnknown: true })
    : undefined;
const WhereOperatorsSchema = ObjectSchema({
    $gt: joi.alternatives(Primitives.number, Primitives.string, Primitives.date),
    $gte: joi.alternatives(Primitives.number, Primitives.string, Primitives.date),
    $lt: joi.alternatives(Primitives.number, Primitives.string, Primitives.date),
    $lte: joi.alternatives(Primitives.number, Primitives.string, Primitives.date),
    $ne: joi.alternatives(Primitives.number, Primitives.string, joi.lazy(() => WhereOperatorsSchema)),
    $not: joi.alternatives(Primitives.number, Primitives.string, Primitives.boolean, joi.lazy(() => WhereOperatorsSchema)),
    $in: joi.array().items(Primitives.number, Primitives.string),
    $notIn: joi.array().items(Primitives.number, Primitives.string),
    $between: joi.array().items(Primitives.number).length(2),
    $notBetween: joi.array().items(Primitives.number).length(2),
    $startsWith: Primitives.string,
    $endsWith: Primitives.string,
    $substring: Primitives.string,
});
